import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {
    Button,
    Card,
    CardHeader,
    Col,
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Row,
    Table,
    Tooltip,
    UncontrolledDropdown,
} from "reactstrap";
import ReviewContactService from "../../../../services/reviewContactService";
import NotificationAlert from "react-notification-alert";
import ReactBSAlert from "react-bootstrap-sweetalert";
import FormInput from "../../../../components/common/form/FormInput";
import _ from "lodash";
import formatFrontendDate from "../../util/formatFrontendDate";
import ReviewService from "../../../../services/reviewService";
import Loader from "../../../Loader";
import FormReactSelect from "../../../../components/common/form/FormReactSelect";
import UtilService from "../../../../services/utilService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';

library.add(fas);

class AudienceList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            alert: null,
            filterName: "",
            filterSurname: "",
            filterCompany: "",
            filteredList: [],
            savedAudienceList: [],
            audienceList: new Set(),
            userSettings: null,
            loading: false,
            selectKey: UtilService.uuidv4(),
            lastContactDates: {},
        };
        this.delete = this.delete.bind(this);
        this.notify = this.notify.bind(this);
    }

    componentDidMount() {
        this.initializeData();

    }

    initializeData() {
        ReviewContactService.list().then((response) => {
            this.setState({list: response, filteredList: response});
            console.log(this.state.filteredList);
            ReviewService.fetchSettingForUser().then(response => {
                this.setState({userSettings: response});
                const audienceIds = response.audiences || [];
                const savedAudienceList = _.filter(this.state.list, contact => audienceIds.includes(contact.uniqueId));
                const selectAudienceList = _.filter(this.state.list, contact => !audienceIds.includes(contact.uniqueId)).map(contact => {
                    const selectName = `${contact.firstName} ${contact.lastName} - ${contact.company.legalName}`;
                    console.log({...contact, selectName});
                    return {...contact, selectName};
                });
                this.setState({savedAudienceList, filteredList: savedAudienceList, selectAudienceList});
                this.setState({selectKey: UtilService.uuidv4()})
                console.log("savedAudienceList", savedAudienceList)
                console.log("selectAudienceList", selectAudienceList)
                this.fetchLastContactDates(savedAudienceList)

            })
        });
    }

    fetchLastContactDates = (savedAudienceList) => {
        savedAudienceList.forEach(contact => {
            ReviewService.lastContactDate(contact.uniqueId).then((response) => {
                this.setState(prevState => ({
                    lastContactDates: {
                        ...prevState.lastContactDates,
                        [contact.uniqueId]: response
                    }
                }));
            });
        });
    }

    onChange = (event) => {
        this.setState({[event.target.name]: event.target.value});
        console.log(this.state);
    }

    onContactChange = (valueObj) => {
        if (!Array.isArray(valueObj)) {
            console.warn("Expected an array but received:", valueObj);
            if(valueObj === null){
                this.setState({savedAudienceList: []});
            } else{
                this.setState({ savedAudienceList: [valueObj] });
            }
        }
        console.log(valueObj);
        this.setState({ savedAudienceList: valueObj });
        console.log(this.state.savedAudienceList);
    };


    applyFilter = () => {
        const {list, filterName, filterSurname, filterCompany,savedAudienceList} = this.state;

        const filteredList = _.filter(savedAudienceList, (contact) => {
            const nameMatches = filterName ? _.includes(_.toLower(contact.firstName), _.toLower(filterName)) : true;
            const surnameMatches = filterSurname ? _.includes(_.toLower(contact.lastName), _.toLower(filterSurname)) : true;
            const companyMatches = filterCompany ? _.includes(_.toLower(contact.company.legalName), _.toLower(filterCompany)) : true;

            return nameMatches && surnameMatches && companyMatches;
        });

        this.setState({filteredList: filteredList});
    }

    clearFilter = () => {
        this.setState({filteredList: this.state.savedAudienceList, filterName: "", filterSurname: "", filterCompany: ""})
    }

    hideDeleteAlert = () => {
        this.setState({
            alert: null
        });
    };

    confirmDeleteAlert = (uniqueId) => {
        this.setState({
            alert: (
                <ReactBSAlert
                    warning
                    style={{display: "block"}}
                    title="Are you sure?"
                    onConfirm={() => this.deleteFromAudience(uniqueId)}
                    onCancel={this.hideDeleteAlert}
                    showCancel
                    confirmBtnBsStyle="danger"
                    confirmBtnText="Yes, delete it!"
                    cancelBtnBsStyle="secondary"
                    cancelBtnText="Cancel"
                    btnSize=""
                >
                    You won't be able to revert this!
                </ReactBSAlert>
            )
        });
    };

    confirmReviewsSend = (uniqueId) => {
        this.setState({
            alert: (
                <ReactBSAlert
                    warning
                    style={{display: "block"}}
                    title="Are you sure, you want to continue sending reviews?"
                    onConfirm={() => this.createReviews()}
                    onCancel={this.hideDeleteAlert}
                    showCancel
                    confirmBtnBsStyle="success"
                    confirmBtnText="Yes, send it!"
                    cancelBtnBsStyle="secondary"
                    cancelBtnText="Cancel"
                    btnSize=""
                >
                    You won't be able to revert this!
                </ReactBSAlert>
            )
        });
    };


    toggleContactSelection = (uniqueId) => {
        const {audienceList} = this.state;
        let updatedAudienceList = new Set(audienceList);

        if (updatedAudienceList.has(uniqueId)) {
            updatedAudienceList.delete(uniqueId);
        } else {
            updatedAudienceList.add(uniqueId);
        }

        this.setState({audienceList: updatedAudienceList});
        console.log(this.state.audienceList);
    };

    delete(uniqueId) {
        this.setState({alert: null})
        ReviewContactService.delete(uniqueId).then((response) => {
            console.log(response);
            this.notify(
                response.responseStatus.toLowerCase(),
                response.responseStatus,
                response.message
            );
            //TODO: TO be fixed with redux implementation
            //   this.props.history.push("/admin/dashboard");
            ReviewContactService.list().then((response) => {
                console.log(response);
                this.setState({list: response, filteredList: response});
            });
        });
    }

    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };
    createReviews = () => {
        console.log(this.state.audienceList)
        if (this.state.userSettings === null) {
            this.notify("error", "Error", "Please set your survey type in settings first!")
            return;
        }
        if (this.state.audienceList.size === 0) {
            this.notify("danger", "Validation", "Please select at least one contact for the audience list!")

        } else {
            this.setState({loading: true});
            const data = {
                audienceList: [...this.state.audienceList]
            }
            ReviewService.createReviewCampaign(data).then((response) => {
                console.log(response);
                this.initializeData();
                this.setState({loading: false});
                this.hideDeleteAlert();
                this.notify("success", "Success", "Your review Campaign has been created Successfully! Contacts will be notified shortly!")
            })
        }
    }

    saveAudiences = () => {
        this.setState({loading: true});
        const contactsUniqueIds = _.map(this.state.savedAudienceList, 'uniqueId');
        console.log(contactsUniqueIds)
        const data = {
            audiences: contactsUniqueIds
        }
        ReviewService.createSetting(data).then((response) => {
            ReviewService.fetchSettingForUser().then(response => {
                this.setState({userSettings: response});
                const audienceIds = response.audiences || [];
                const savedAudienceList = _.filter(this.state.list, contact => audienceIds.includes(contact.uniqueId));
                const selectAudienceList = _.filter(this.state.list, contact => audienceIds.includes(contact.uniqueId));
                this.setState({savedAudienceList,filteredList: savedAudienceList, selectAudienceList});
                this.setState({selectKey: UtilService.uuidv4()})
                console.log(savedAudienceList)
                this.fetchLastContactDates(savedAudienceList)
            })
            this.setState({loading: false});
            console.log(response)
            this.notify('success', 'Added Audience', 'Your contacts are added successfully to the audience list!')
        })
            .catch((error) => {
                this.setState({loading: false});
                this.notify('danger', 'Added Failed', 'Your contacts were not added to the audience list!')
            })

    }

    lastContactDate = (contactId) => {
        console.log("contactId", contactId);
        let date = "No Data Present"
        ReviewService.lastContactDate(contactId).then((response) => {
             date = response;
        })
        return date
    }

    deleteFromAudience = (uniqueId) => {
        this.setState({alert: null})
        this.setState({loading: true});
        ReviewService.deleteAudience(uniqueId).then((response) => {
            ReviewService.fetchSettingForUser().then(response => {
                this.setState({userSettings: response});
                const audienceIds = response.audiences || [];
                const savedAudienceList = _.filter(this.state.list, contact => audienceIds.includes(contact.uniqueId));
                const selectAudienceList = _.filter(this.state.list, contact => !audienceIds.includes(contact.uniqueId)).map(contact => {
                    const selectName = `${contact.firstName} ${contact.lastName} - ${contact.company.legalName}`;
                    console.log({...contact, selectName});
                    return {...contact, selectName};
                });

                this.setState({savedAudienceList,filteredList: savedAudienceList, selectAudienceList});
                this.setState({selectKey: UtilService.uuidv4()})
                this.notify('success', 'Audience Updated', 'Your audience list is updated!')
            })
            this.setState({loading: false});
        })
    }


    render() {
        let obj = this;
        return (
            <>
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                {this.state.loading ? (<Loader/>) : ("")}
                <SimpleHeader
                    name="List"
                    parentName="Audience"
                    heading="XareGrwoth"
                    // newBtnUrl="/user/contact/create"
                    // newBtnText="Create Review Contact"
                />
                {this.state.alert}
                <Container className="mt--6" fluid>
                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardHeader className="border-0">
                                    <Row className="align-items-center">
                                        <div className="col">
                                            <h3 className="mb-0">Audience List (List of companies to send a review request to)
                                                <div style={{float: "right", }}>
                                                    <Button style={{zIndex: "99",
                                                        position: "relative"}}
                                                        outline
                                                        color="default"
                                                        // size="sm"
                                                        onClick={(e) => {
                                                            this.confirmReviewsSend()
                                                        }}
                                                    >
                                                        Send Reviews ({this.state.audienceList.size || 0})
                                                    </Button>
                                                </div>
                                            </h3>

                                        </div>
                                    </Row>
                                    <Row>
                                        <Col sm="10">
                                            <br/>
                                            <FormReactSelect
                                                selectKey={this.state.selectKey}
                                                isMulti={true}
                                                className="form-control-label"
                                                isSearchable={true}
                                                label="Add Contacts to Audience List"
                                                name={"contactRole"}
                                                onChange={this.onContactChange}
                                                optionValue={"uniqueId"}
                                                // defaultValue={this.state.savedAudienceList}
                                                optionList={this.state.selectAudienceList}
                                                optionLabel={"selectName"}
                                                placeHolder="Select audience from your contacts"
                                                errorMsg={this.props?.errorObj?.contactRole || ""}
                                            />

                                        </Col>
                                        <Col sm="2" className="d-flex align-items-end justify-content-center" style={{ top: "-24px" }}>
                                            <Button color="default" outline
                                                    size="sm"
                                                    onClick={() => this.saveAudiences()}>
                                                Add to Audience
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <p style={{fontStyle: "italic", color: "gray"}}>
                                            Use the filters below to narrow down your search results.
                                        </p>
                                    </Row>
                                    <Row>
                                        {/*<Col sm={2}>
                        <FormInput
                            name="dateFrom"
                            className="form-control-label"
                            id="date"
                            placeholder="inputPlaceHolder.meetingReport.date"
                            type="date"
                            onChange={this.onChange}
                            value={this.state.dateFrom || ""}
                            label="Date From"
                        />
                      </Col>
                      <Col sm={2}>
                        <FormInput
                            name="dateTo"
                            className="form-control-label"
                            id="date"
                            placeholder="inputPlaceHolder.meetingReport.date"
                            type="date"
                            onChange={this.onChange}
                            value={this.state.dateTo || ""}
                            label="Date To"
                        />
                      </Col>*/}
                                        <Col md="2">
                                            <FormInput
                                                name="filterName"
                                                className="form-control-label"
                                                id="name"
                                                placeholder="Name"
                                                type="text"
                                                onChange={this.onChange}
                                                label="Name"
                                                value={this.state?.filterName || ""}
                                                // errorMsg={this.props.errorObj?.name || ""}
                                            />
                                        </Col>
                                        <Col md="2">
                                            <FormInput
                                                name="filterSurname"
                                                className="form-control-label"
                                                id="countryName"
                                                placeholder="Surname"
                                                type="text"
                                                onChange={this.onChange}
                                                label="Surname"
                                                value={this.state?.filterSurname || ""}
                                                // errorMsg={this.props.errorObj?.name || ""}
                                            />
                                        </Col>
                                        <Col md="2">
                                            <FormInput
                                                name="filterCompany"
                                                className="form-control-label"
                                                id="companyName"
                                                placeholder="Company Name"
                                                type="text"
                                                onChange={this.onChange}
                                                label="Company Name"
                                                value={this.state?.filterCompany || ""}
                                                // errorMsg={this.props.errorObj?.name || ""}
                                            />
                                        </Col>
                                        <Col sm={3} style={{marginTop: "30px"}}>
                                            <Button size="md" outline color="default" type="button"
                                                    onClick={this.applyFilter}
                                            >
                                                Apply Filter
                                            </Button>
                                            <Button color="default" size="md" outline type="button"
                                                    onClick={this.clearFilter}
                                            >
                                                Clear Filter
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <div className="mb-2">

                                </div>
                                <Table className="align-items-center table-flush" responsive>
                                    <thead className="thead-light">

                                    <tr>
                                        <th className="sort" data-sort="name" scope="col">
                                            <input
                                                type="checkbox"
                                                checked={this.state.filteredList.length > 0 && this.state.filteredList.every(contact => this.state.audienceList.has(contact.uniqueId))}
                                                onChange={(e) => {
                                                    const allSelected = e.target.checked;
                                                    const updatedAudienceList = new Set(this.state.audienceList);
                                                    if (allSelected) {
                                                        this.state.filteredList.forEach(contact => updatedAudienceList.add(contact.uniqueId));
                                                    } else {
                                                        this.state.filteredList.forEach(contact => updatedAudienceList.delete(contact.uniqueId));
                                                    }
                                                    this.setState({audienceList: updatedAudienceList});
                                                }}
                                            /> All
                                        </th>
                                        <th scope="col">Actions</th>
                                        <th className="sort" data-sort="name" scope="col">
                                            #
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            First Name
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            Last Name
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            Title
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            Company Name
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            Email Address
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            Last Contacted
                                        </th>
                                       {/* <th className="sort" data-sort="status" scope="col">
                                            HotListed
                                        </th>*/}

                                    </tr>
                                    </thead>
                                    <tbody className="list">
                                    {this.state.filteredList.map((value, index) => {
                                        return (
                                            <tr key={index} /*style={{display: ContactPermissions.read()}}*/>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        disabled={value?.hotlisted}
                                                        checked={this.state.audienceList.has(value.uniqueId)}
                                                        onChange={() => obj.toggleContactSelection(value.uniqueId)}
                                                    />
                                                </td>
                                                <td className="budget">
                                                    <div id={`delete-tooltip-${index}`}>
                                                        <Button size="sm" onClick={(e) => {
                                                            e.preventDefault();
                                                            this.confirmDeleteAlert(value.uniqueId);
                                                        }}>
                                                            <FontAwesomeIcon icon={['fas', 'trash']}/>
                                                        </Button>
                                                        <Tooltip
                                                            placement="top"
                                                            isOpen={this.state[`tooltipOpen${index}`]}
                                                            target={`delete-tooltip-${index}`}
                                                            toggle={() => this.setState({[`tooltipOpen${index}`]: !(this.state[`tooltipOpen${index}`] || false)})}
                                                        >
                                                            Delete from audience list
                                                        </Tooltip>
                                                    </div>
                                                </td>
                                                <td className="budget">{index + 1}</td>
                                                {/*<td className="budget">{formatFrontendDate(value.dateCreated)}</td>*/}
                                                <td className="budget">{value.firstName}</td>
                                                <td className="budget">{value.lastName}</td>
                                                <td className="budget">{value.title}</td>
                                                <td className="budget">{value.company.legalName}</td>
                                                {/*<td className="budget">{value.contactRole}</td>*/}
                                                <td className="budget">{value.email || "N/A"}</td>
                                                <td className="budget">
                                                    {this.state.lastContactDates[value.uniqueId] || "No Data Present"}
                                                </td>
                                                {/*<td className="budget">
                                                    {value?.hotlisted === true ? "Yes" : "No"}
                                                </td>*/}
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </Table>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}

export default AudienceList;
